import { navOptions } from "~/content/navLinks"

export const metadataConfig = {
  [navOptions.services.href]: {
    title: "Services",
    canonicalLink: navOptions.services.href,
  },
  [navOptions.serviceslist.personal.href]: {
    title: "Personal & Home Care Support | NDIS Disability Services",
    description:
      "Discover trusted home care support and disability assistance in Australia. Incluso provide in-home care services for disabled individuals in Sydney, Melbourne and Adelaide.",
    canonicalLink: navOptions.serviceslist.personal.href,
  },
  [navOptions.serviceslist.support.href]: {
    title: "NDIS Support Coordination Services, Plan & Funding",
    description:
      "Incluso’s support coordination services in Australia help you manage your NDIS plan, maximise NDIS funding and find NDIS support workers near you in Sydney, Melbourne and Adelaide.",
    canonicalLink: navOptions.serviceslist.support.href,
  },
  [navOptions.serviceslist.community.href]: {
    title: "Community Engagement | Community Participation Support",
    description:
      "Find tailored community engagement services Australia. From NDIS community participation activities to personalised support, connect socially in Sydney, Melbourne or Adelaide.",
    canonicalLink: navOptions.serviceslist.community.href,
  },
  [navOptions.serviceslist.accommodation.href]: {
    title: "Accommodation and Supported Independent Living (SIL)",
    description:
      "Find tailored Supported Independent Living (SIL) and NDIS Accommodation Support in Australia. We offer personalised SIL services in Sydney, Adelaide, Melbourne and Coburg.",
    canonicalLink: navOptions.serviceslist.accommodation.href,
  },
  [navOptions.serviceslist.transport.href]: {
    title: "NDIS Transport Services in Australia | Travel Assistance",
    description:
      "Discover reliable NDIS transport services in Australia with personalised NDIS travel support. We’re your trusted NDIS travel providers in Adelaide, Sydney and Melbourne.",
    canonicalLink: navOptions.serviceslist.transport.href,
  },
  [navOptions.pricing.personal.href]: {
    title: "Personal and In-Home Care Support Pricing in Australia",
    description:
      "Explore affordable personal care support in Australia, with personal and in-home care support pricing tailored to your needs. Get a free quote for in-home care costs and services.",
    canonicalLink: navOptions.pricing.personal.href,
  },

  [navOptions.insights.href]: {
    title: "Insights - Latest News, Insights & Customer Stories",
    canonicalLink: navOptions.insights.href,
  },

  [navOptions.aboutUs.href]: {
    title: "About Us",
    canonicalLink: navOptions.aboutUs.href,
  },
  [navOptions.aboutUslist.whyIncluso.href]: {
    title: "Why Incluso",
    canonicalLink: navOptions.aboutUslist.whyIncluso.href,
  },
  [navOptions.aboutUslist.customerExp.href]: {
    title: "Customer Experience",
    canonicalLink: navOptions.aboutUslist.customerExp.href,
  },
  [navOptions.aboutUslist.ourTeam.href]: {
    title: "Our Team",
    canonicalLink: navOptions.aboutUslist.ourTeam.href,
  },
  [navOptions.aboutUslist.career.href]: {
    title: "Career",
    canonicalLink: navOptions.aboutUslist.career.href,
  },
  [navOptions.aboutUslist.community.href]: {
    // title: "Community and Sustainability",
    title: `Supporting Australian Communities Through Local Procurement and Initiatives`,
    description: `Incluso supports Australian communities through employee volunteering programs, local procurement Australia, academic scholarships Australia and championing reconciliation Australia. Learn how we're shaping a better tomorrow.`,
    canonicalLink: navOptions.aboutUslist.community.href,
  },
  [navOptions.aboutUslist.social.href]: {
    title: "Social Responsibility",
    canonicalLink: navOptions.aboutUslist.social.href,
  },
  [navOptions.aboutUslist.environmental.href]: {
    // title: "Environmental Sustainability",
    title:'Environmental Sustainability & Carbon Neutrality Since 2019',
    description:'Leading the way in environmental sustainability in Australia. Incluso has been carbon neutral since 2019, supporting renewable energy, cutting emissions, and working towards zero waste with innovative practices.',
    canonicalLink: navOptions.aboutUslist.environmental.href,
  },
  [navOptions.aboutUslist.reconciliation.href]: {
    // title: "Reconciliation",
    title: `Reconciliation Australia: Supporting First Nations Cultures and Careers`,
    description: `Incluso’s Reconciliation Strategy prioritises building inclusion and empowering Aboriginal and Torres Strait Islander communities through cultural awareness, employment and partnerships.`,
    canonicalLink: navOptions.aboutUslist.reconciliation.href,
  },

  [navOptions.contactUs.href]: {
    title: "Contact Us",
    canonicalLink: navOptions.contactUs.href,
  },
  [navOptions.contactUsList.referral.href]: {
    title: "Participant and Referral Intake Form",
    canonicalLink: navOptions.contactUsList.referral.href,
  },
}
